import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TimeService } from "@app2/shared/services/time.service";

@Component({
    selector: "timestamp-dropdown",
    template: `
        <pr-dropdown align="right" *dsPermissionsRequired="'EVENT_VIEW'">
            <span pr-dropdown-trigger class="inline link-dropdown">
                {{ timestamp | timestamp }} <i class="far fa-chevron-down"></i>
            </span>
            <ul pr-dropdown-body
                class="pr-dropdown">
                <li class="no-hover">
                    <header>{{ 'SEARCH_AROUND_EVENT' | localize }}</header>
                </li>
                <li class="narrow-search-option-container">
                    <a class="narrow-search-option"
                       dsRouterLink="/search"
                       [queryParams]="getQueryStateParams(1)">
                        <i class="far fa-search visible-icon"></i> {{ "SEARCH_AROUND_1M" | localize }}
                    </a>
                </li>
                <li class="narrow-search-option-container">
                    <a class="narrow-search-option"
                       dsRouterLink="/search"
                       [queryParams]="getQueryStateParams(5)">
                        <i class="far fa-search visible-icon"></i> {{ "SEARCH_AROUND_5M" | localize }}
                    </a>
                </li>
            </ul>
        </pr-dropdown>
        <span *dsPermissionsRequired="'!EVENT_VIEW'" class="inline" align="right">
            {{ timestamp | timestamp }}
        </span>
    `,
    styles: [`
        /* Make the clickable area of the "a" equal to the area of the "li" */
        pr-dropdown ul li.narrow-search-option-container {
            display: flex;
            padding-right: 0;
        }

        pr-dropdown ul[pr-dropdown-body] {
            margin-top: 0;
        }

        .narrow-search-option {
            flex-grow: 1;
        }

        .fa-chevron-down {
            font-size: 12px;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimestampDropdownComponent {
    @Input() timestamp: date;

    constructor(private readonly timeService: TimeService) {
    }

    getQueryStateParams(rangeInMinutes): { query: string, begin: date, end: date } {
        const base = this.timeService.timeZoneMoment(this.timestamp);
        return {
            query: "",
            begin: base.clone().subtract(rangeInMinutes, "minutes").toISOString(),
            end: base.clone().add(rangeInMinutes, "minutes").toISOString(),
        };
    }
}
